/**
 * Custom escape function to replace deprecated escape()
 * This function performs the same operation as the deprecated escape()
 * which was used to encode Unicode characters for URL encoding
 */
export function myEscape(str: string): string {
  return str.replace(/[\u0080-\uFFFF]/g, (match) => {
    const code = match.charCodeAt(0)
    if (code < 256) {
      return `%${code.toString(16).padStart(2, '0').toUpperCase()}`
    } else {
      return `%u${code.toString(16).padStart(4, '0').toUpperCase()}`
    }
  })
}

/**
 * Custom unescape function to replace deprecated unescape()
 * This function performs the same operation as the deprecated unescape()
 * which was used to decode Unicode characters from URL encoding
 */
export function myUnescape(str: string): string {
  return str.replace(/%u([0-9a-fA-F]{4})/g, (match, digits) => {
    return String.fromCharCode(Number.parseInt(digits, 16))
  }).replace(/%([0-9a-f]{2})/gi, (match, digits) => {
    return String.fromCharCode(Number.parseInt(digits, 16))
  })
}

/**
 * Encodes a string to base64 with proper UTF-8 handling
 */
export function encodeBase64(value: string): string {
  return btoa(myUnescape(encodeURIComponent(value)))
}

/**
 * Decodes a base64 string with proper UTF-8 handling
 */
export function decodeBase64(value: string): string {
  return decodeURIComponent(myEscape(atob(value)))
}

/**
 * Converts base64 string to JSON object
 */
export function base64ToJson(value: string): any {
  return JSON.parse(decodeBase64(value))
}

/**
 * Converts object to base64 string
 */
export function jsonToBase64(value: any): string {
  return encodeBase64(JSON.stringify(value))
}

/**
 * Simple base64 encoding using btoa()
 */
export function Encode64(obj: string): string {
  return obj ? btoa(obj) : ''
}

/**
 * Simple base64 decoding using atob()
 */
export function Decode64(obj: string): string {
  return obj ? atob(obj) : ''
}

/**
 * UTF-8 safe base64 encoding with error handling
 */
export function Encode64UTF8(obj: string): string {
  if (!obj)
    return ''
  try {
    return btoa(myUnescape(encodeURIComponent(obj)))
  } catch (e) {
    console.error('Encode64UTF8 error:', e)
    return ''
  }
}

/**
 * UTF-8 safe base64 decoding with error handling
 */
export function Decode64UTF8(obj: string): string {
  if (!obj)
    return ''
  try {
    return decodeURIComponent(myEscape(atob(obj)))
  } catch (e) {
    console.error('Decode64UTF8 error:', e)
    return ''
  }
}

/**
 * Validates if a string is valid base64
 */
export function isValidBase64(str: string): boolean {
  try {
    atob(str)
    return true
  } catch {
    return false
  }
}

/**
 * Decodes base64 and parses as JSON
 */
export function DecodeData(obj: string): any {
  return obj ? JSON.parse(Decode64(obj)) : []
}

/**
 * Stringifies and encodes to base64
 */
export function EncodeData(obj: any): string {
  return obj ? Encode64(JSON.stringify(obj)) : ''
}
